import { Store } from 'components/common/types/Store.types';
import { useSelector } from 'react-redux';
import { CreateProductHeader } from '../CreateProductContent/CreateProductHeader/CreateProductHeader';
import { FolderInput } from './FolderInput/FolderInput';

export const CreateProductSidebar: React.FC = () => {
  const productId = useSelector((state: Store) => state.productManagement.originalProductId);

  return (
    <div
      className="w-[var(--campaign-drawer-width)] shrink-0 bg-white h-full border-x border-neutral-950-opacity-10 flex flex-col overflow-auto"
      data-test-id="create-product-sidebar"
    >
      <div className="flex flex-col pt-2" data-test-id="create-product-sidebar-content">
        <FolderInput />
        <div className="flex flex-col mx-6 gap-2">
          <CreateProductHeader />
          <p className="body-sm text-neutral-400">{productId ?? 'Product ID'}</p>
        </div>
      </div>
    </div>
  );
};
